angular.module("acl.storyboard.storyboard").factory("ComponentLoader", function() {
  return {
    saveModal: function(modalProps, element) {
      return storyboardSaveModal(modalProps, element);
    },
  };
});
